/**
 * Custom segmented selector for Semana | Mes | Año.
 * Uses an absolute "indicator" that slides between options for a fluid
 * motion that matches the wellness aesthetic (no rectangle tabs).
 */
import { useLayoutEffect, useRef, useState } from "react";

export default function ViewToggle({ options, value, onChange, testId = "calendar-view-toggle" }) {
  const containerRef = useRef(null);
  const [indicator, setIndicator] = useState({ left: 0, width: 0 });

  useLayoutEffect(() => {
    const root = containerRef.current;
    if (!root) return;
    const active = root.querySelector(`[data-value="${value}"]`);
    if (active) {
      setIndicator({ left: active.offsetLeft, width: active.offsetWidth });
    }
  }, [value, options]);

  return (
    <div
      ref={containerRef}
      className="relative inline-flex items-center rounded-full p-1 backdrop-blur-md border"
      style={{
        background: "rgba(255, 251, 240, 0.55)",
        borderColor: "rgba(218, 207, 186, 0.5)",
      }}
      data-testid={testId}
    >
      <span
        aria-hidden="true"
        className="absolute top-1 bottom-1 rounded-full transition-all duration-300 ease-out"
        style={{
          left: indicator.left,
          width: indicator.width,
          background: "linear-gradient(135deg, #DEE8DD 0%, #C5D7C2 100%)",
          boxShadow: "0 4px 16px -8px rgba(42,157,143,0.35), 0 1px 0 rgba(255,255,255,0.7) inset",
        }}
      />
      {options.map((opt) => (
        <button
          key={opt.id}
          data-value={opt.id}
          onClick={() => onChange(opt.id)}
          className={`relative z-10 px-5 py-1.5 rounded-full font-dmsans text-sm transition-colors ${
            value === opt.id ? "text-sage-700" : "text-ink-600 hover:text-ink-900"
          }`}
          data-testid={`${testId}-${opt.id}`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
